import { render, staticRenderFns } from "./pushbuttonalertshistory.vue?vue&type=template&id=644f759c&scoped=true"
import script from "./pushbuttonalertshistory.vue?vue&type=script&lang=js"
export * from "./pushbuttonalertshistory.vue?vue&type=script&lang=js"
import style0 from "./pushbuttonalertshistory.vue?vue&type=style&index=0&id=644f759c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f759c",
  null
  
)

export default component.exports